<template>
<div>

	<ul class="title-nav">
		<li>
			<div v-on:click="routeBack()" class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">email</i> EMAIL</div>
		</li>
	</ul>

	<div class="category">
		<div class="category-title">ACTIVE EMAIL</div>
		<div class="property-row">
			<div class="text-break property-locked">
				{{agent.email}}
			</div>
		</div>
		<div v-if="mode == 'view'" class="property-row">
			<button v-on:click="editShow" class="btn btn-light btn-sm float-right">Change Email</button>
		</div>
	</div>

	<form v-if="mode == 'edit'" class="category form-group" v-on:submit.prevent="submitChange">
		
		<div class="category-title" for="signUpEmail">NEW EMAIL</div>
		<div class="property-row">
			<input type="email" class="form-control" id="email" aria-describedby="emailHelp" 
				placeholder="Enter new email" v-model="newEmail"
				v-bind:class="{'is-invalid':error}"/>
			<div class="invalid-feedback">
				{{error}}
		   </div>
		</div>
		<div class="property-row">
			<button v-on:click.prevent="editCancel" class="btn btn-light">Cancel</button>
			<button class="btn btn-dark float-right" type="submit">Update</button>
		</div>
	</form>

	<contentLoading :loading="loading"/>
	<contentAlert :alert="alert"/>
</div>
</template>

<script>

import contentAlert from '../content/content-alert';
import contentLoading from '../content/content-loading';

export default {
	components:{
		contentAlert,
		contentLoading
	},
	data: function(){
		return {
			error:null,
			loading:false,
			mode:'view',
			newEmail:'',
			alert:null,
		}
	},
	props: {
		agent:{
			type:Object
		},
	},
	methods:{
		routeBack:function(){
			this.$router.push({
				name:'agent',
			});
		},
		editCancel:function(){
			this.mode = 'view';
		},
		editShow:function(){
			this.mode = 'edit';
		},
		submitChange:function(){
			this.loading = true;
			this.$store.dispatch('AGENT_EMAIL_CHANGE', {email:this.newEmail, userId:this.agent.id}).then((res)=>{
				this.loading = false;
				this.alert = 'email changed successfully';
				this.mode = 'view';
			}).catch((err)=>{
				this.loading = false;
			});
		},
	},
	watch:{
	}
}

</script>


// WEBPACK FOOTER //
// src/components/agent/agent-email.vue